import api from "src/apis/api"

// Gupshup Communication Hub credentials. The API key is write-only: the server
// returns `api_key_present` (boolean) rather than the key itself.
export async function fetchGupshupSettings() {
  const { data } = await api.get("/api/v1/communications/gupshup_settings")
  return data.config
}

export async function updateGupshupSettings(config) {
  const { data } = await api.patch("/api/v1/communications/gupshup_settings", { config })
  return data.config
}

export async function testGupshupConnection(to_address) {
  const { data } = await api.post("/api/v1/communications/gupshup_settings/test", { to_address })
  return data
}
